module.exports = __webpack_public_path__ + "images/4d5e165d.McDonaldsLogo.png";


//////////////////
// WEBPACK FOOTER
// ./core-dms/projects/candao-dms-std/orderLocation/images/McDonaldsLogo.png
// module id = 540
// module chunks = 99